import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';

import DashboardHero from './HomeDashboard/DashboardHero';
import DashboardStats from './HomeDashboard/DashboardStats';
import RecentGroups from './HomeDashboard/RecentGroups';
import ExploreCards from './HomeDashboard/ExploreCards';
import DigitaliadaContent from './HomeDashboard/DigitaliadaContent';
import loadClassesHook from '../../MyComponents/Hooks/loadClassesHook';
import collectionsApi from '../../Api/collectionsApi';
import { GA_EVENT_TREE } from '../../gaConstants';

// How many groups the home shows before pointing at the groups page.
const RECENT_COUNT = 3;

/**
 * The signed-in home: greet, start a group, show the numbers and the recent
 * groups, then what else there is to explore. Rendered inside the app
 * drawer's grid, hence the single full-width grid item.
 */
const HomeLoggedIn = ({ profile, allowedGroups }) => {
    const history = useHistory();
    // null until the count arrives, so the tile can show a pending state
    // rather than a misleading zero.
    const [boardCount, setBoardCount] = useState(null);
    const { dataAll, isLoading } = loadClassesHook(allowedGroups);

    useEffect(() => {
        collectionsApi
            .getBoardsCount()
            .then((res) => setBoardCount((res && res.data && res.data.count) || 0))
            .catch((err) => {
                console.log(err);
                setBoardCount(0);
            });
    }, []);

    const lessonStart = (classId) => {
        window.logAppActivity(GA_EVENT_TREE.manageGroups.actions.start);
        history.push('/lesson/' + classId);
    };

    const givenName = (profile.extended && profile.extended.first_name) || (profile.name || '').split(' ')[0];

    return (
        <Grid item xs={12}>
            <DashboardHero givenName={givenName} />
            <RecentGroups
                groups={dataAll.slice(0, RECENT_COUNT)}
                total={dataAll.length}
                profile={profile}
                onStart={lessonStart}
                loading={isLoading}
            />
            <DashboardStats groupsCount={dataAll.length} boardsCount={boardCount} loading={isLoading} />
            <ExploreCards />
            <DigitaliadaContent />
        </Grid>
    );
};

const mapStateToProps = (state) => {
    const { profile } = state;
    return { profile, allowedGroups: profile.allowedGroups };
};

export default connect(mapStateToProps)(HomeLoggedIn);
